import SidebarItem from "./SidebarItem";
import { sidebarMenuRoutes } from "@/routes";

const Sidebar: React.FC = () => {
  return (
    <div className="space-y-2">
      {Object.values(sidebarMenuRoutes).map((item) => (
        <SidebarItem
          key={item.label}
          href={item.to}
          Icon={item.icon}
          label={item.label}
          active={false}
        />
      ))}
    </div>
  );
};

export default Sidebar;
